export default __webpack_public_path__ + "static/media/image-mars.1b224c86.png";